import { IS_STANDALONE, getStandaloneSpaceId } from "./config";

if (IS_STANDALONE) {
  getStandaloneSpaceId();
}
